import { useToast } from './useToast';
import { useCheckInStore } from '@/stores/checkin-store';
import { GeneralQuestion } from '@/interfaces/check/check-in.interface';

export const useCheck = () => {
  const { showToast } = useToast();
  const { uploadIncidenceImage } = useCheckInStore();

  const uploadImage = async (
    img64: string,
    question: GeneralQuestion,
    bookingId: string,
    type: string,
  ) => {
    try {
      const form = {
        QuestionId: question.QuestionId,
        image: img64,
      };

      const { success, data, error } = await uploadIncidenceImage(form, bookingId, type);
      if (success) {
        return data;
      } else {
        throw new Error(error);
      }
    } catch (error) {
      await showToast(error instanceof Error ? error.message : 'Unknown error', 'error');
    }
  };
  return { uploadImage };
};
